import styled from "styled-components";

export default styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
